





































































# import settings from '@/settings'
import n from '@/utils/notifications'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'roles_table'

    props:{
        company_uid:{
            required: true
        }
    }

    data: ()->
        loading: true
        dialog_visible: false
        errors: {}
        datas: []
        roles: []
        edit_text: ''
        directory_show_index: -1
        profiles: [
            {id:0, name:'Aucun'}
            {id:1, name:'Dirigeant'}
        ]
        role:{
            uid:''
            profile:0
            name:''
        }
        tableKey: ''

    methods:
        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        # disabled: (row_index, role_index)->
        #     if row_index == 0
        #         return false
        #     else if row_index == parseInt(@directory_show_index)
        #         # ## Disable contact_detail "directory_show" access for role which hasn't manage_all or manage_all_but_superiors
        #         if @datas[2]['access_role_set'][role_index].checked or @datas[3]['access_role_set'][role_index].checked
        #             if @datas[0]['access_role_set'][role_index]['checked']
        #                 return true
        #             else
        #                 return false
        #         else if !@datas[2]['access_role_set'][role_index].checked and !@datas[3]['access_role_set'][role_index].checked
        #             @datas[@directory_show_index]['access_role_set'][role_index]['checked'] = false
        #             return true
        #     else
        #         return @datas[0]['access_role_set'][role_index]['checked']

        save_role: ()->
            # console.log "SAVE ROLE", @role
            self = @
            m.run('save_company_role', [@company_uid, @role.uid, @role.name, @role.profile])
            .then (resp)->
                # console.log "SAVE COMPANY ROLE ", resp.body.data
                if resp.body.data.role_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.role_form_mutation.errors.length > 0
                    self.errors = resp.body.data.role_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    # console.log "ROLE ADDED", resp.body.data
                    self.errors = {}
                    n.success()
                    self.dialog_visible = false
                    if self.role.uid != ''
                        self.roles.filter (x)->
                            if x.uid == self.role.uid
                                x.name = self.role.name
                                if self.role.profile == 1
                                    x.profile_name = "Dirigeant"
                                else
                                    x.profile_name = null
                    else
                        self.datas = []
                        self.get_role_set()
                    self.tableKey = +new Date()
            .catch (resp)->
                n.catch_error(resp, "roles_table: save_role()")

        edit_role: (role)->
            @errors = {}
            if role?
                @edit_text = 'Editer'
                @role.uid = role.uid
                @role.name = role.name
                if role.profile_name == "Dirigeant"
                    @role.profile = 1
                else
                    @role.profile = 0
            else
                @edit_text = 'Ajouter'
                @role = {
                    uid:''
                    profile:0
                    name:''
                }
            @dialog_visible = true
            return

        delete_role: (role_uid)->
            # console.log  "DELETE ROLE", role_uid
            self = @
            @$confirm("Êtes-vous sûr·e de vouloir supprimer ce rôle ?", 'Confirmation', {
                confirmButtonText: 'Oui',
                cancelButtonText: 'Annuler'
                })
                .then ()->
                    # console.log "ROLE DELETE", role_uid
                    m.run('delete_role', [role_uid])
                    .then (resp)->
                        # console.log "DELETE USER", resp.body.data.role_deletion
                        if resp.body.data.role_deletion.ok
                            n.success()
                            self.get_role_set()
                        else
                            n.gql_error("roles_table: delete_role: then", resp.body.data.role_deletion.message)
                    .catch (resp)->
                        n.catch_error(resp, "roles_table: delete_role()")
                .catch (cancel)->
                    return

        checkbox_clicked: (row, row_index, role_index)->
            # console.log "CHECKBOW CLICKED", row.access.group, row.access.subgroup, row.access_role_set[role_index].checked
            # console.log "CHECKBOW CLICKED", row_index, role_index
            # if row_index == 0
            #     for d in @datas
            #         d.access_role_set[role_index].checked = row.access_role_set[role_index].checked
            if row_index > 0
                if row.group_line
                    if row.access.subgroup == ''
                        for d in @datas
                            if d.access.group == row.access.group
                                d.access_role_set[role_index].checked = row.access_role_set[role_index].checked
                    else
                        for d in @datas
                            if d.access.group == row.access.group and d.access.subgroup == row.access.subgroup
                                d.access_role_set[role_index].checked = row.access_role_set[role_index].checked

                all_checked = group_checked = sub_checked = row.access_role_set[role_index].checked
                group_line_index = subgroup_line_index = -1
                for index, d of @datas
                    if d.group_line and d.access.name == row.access.group
                        group_line_index = index
                    if d.group_line and d.access.name == row.access.subgroup
                        subgroup_line_index = index
                    if !d.group_line and d.access.group == row.access.group
                        group_checked = group_checked and d.access_role_set[role_index].checked
                    if !d.group_line and d.access.group == row.access.group and d.access.subgroup == row.access.subgroup
                        sub_checked = sub_checked and d.access_role_set[role_index].checked
                    if index > 0 and !d.group_line
                        all_checked = all_checked and d.access_role_set[role_index].checked

                if group_line_index >= 0
                    @datas[group_line_index]['access_role_set'][role_index].checked = group_checked
                if subgroup_line_index >= 0
                    @datas[subgroup_line_index]['access_role_set'][role_index].checked = sub_checked
                @datas[0]['access_role_set'][role_index].checked = all_checked

        table_row_class_name: ({row, rowIndex})->
            classes = ''
            if row.group_line == true
                if row.access.name == row.access.group
                    classes = 'group'
                else if row.access.name == row.access.subgroup
                    classes = 'subgroup'
            return classes

        table_cell_class_name: ({row, column, rowIndex, columnIndex})->
            classes = ''
            if columnIndex == 0 and rowIndex > 0
                if row.group_line == true and row.access.name == row.access.subgroup
                    classes = 'padding1'
                else if row.group_line == false
                    if row.access.subgroup != ''
                        classes = 'padding2'
                    else
                        classes = 'padding1'
            return classes

        save: ()->
            # console.log "SAVE"
            self = @
            m.run('save_access_role_set', [@datas])
            .then (resp)->
                # console.log "ACCESS ROLE MUTATION ", resp.body.data.access_role_mutation
                if resp.body.data.access_role_mutation.ok
                    self.loading = true
                    self.get_access_set(self.company_uid)
                    n.success()
                else
                    n.error("roles_table: save: then", resp.body.data.access_role_mutation.message)
            .catch (resp)->
                n.catch_error(resp, "roles_table: save()")

        get_role_set: ()->
            self = @
            q.run('get_company_roles', [@company_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("roles_table: get_role_set: then" ,e.message)
                else
                    self.roles = resp.body.data.company_role_set
                    # console.log "ROLES ", self.roles
                    if self.role.uid == ''
                        self.loading = true
                        self.get_access_set(self.company_uid)
            .catch (resp)->
                n.catch_error(resp, "roles_table: get_role_set()")

        get_access_set: (company_uid)->
            self = @
            q.run('get_company_roles_accesses', [company_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("roles_table: get_access_set: then" ,e.message)
                else
                    self.datas = resp.body.data.roles_table_set
                    for k,v of self.datas
                        if v['access']['label'] == 'directory_show'
                            self.directory_show_index = k
                            break
                    self.loading = false
                    # console.log "GET ROLES ACCESSES : ", self.datas
            .catch (resp)->
                n.catch_error(resp, "roles_table: get_access_set()")

    beforeMount: ()->
        @get_role_set()
}

